<template>
  <MModal :show="true" title="Code Regenerated" type="warning">
    <template #content>
      <p class="regenerate-message">
        Your verification code has been regenerated. Please make note of your new code as the
        previous link in your email is no longer valid.
      </p>
      <div class="code-display">
        <span v-for="(digit, index) in codeDigits" :key="index" class="code-digit">
          {{ digit }}
        </span>
      </div>
    </template>

    <template #footer>
      <MButton class="start-button" @click="startScreener" :disabled="loading">
        <font-awesome-icon
          v-if="loading"
          :icon="faSpinner"
          :spin="true"
          class="fast-spin spinner"
        />
        <span v-else>Start</span>
      </MButton>
    </template>
  </MModal>
</template>

<script setup>
import { computed, ref } from 'vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import MButton from '@/components/MButton.vue'
import MModal from './MModal.vue'

const props = defineProps({
  code: {
    type: String,
    required: true,
    validator: (value) => value.length === 4 && /^\d+$/.test(value)
  }
})

const emit = defineEmits(['startScreener'])
const loading = ref(false)
const codeDigits = computed(() => props.code.split(''))

const startScreener = () => {
  loading.value = true
  emit('startScreener')
}
</script>

<style lang="scss" scoped>
.regenerate-message {
  color: #666;
  margin-bottom: 2rem;
  line-height: 1.5;
}

.code-display {
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-bottom: 2rem;
}

.code-digit {
  background-color: $light;
  border: 2px solid #ddd;
  border-radius: 8px;
  padding: 1rem 1.5rem;
  font-size: 2rem;
  font-weight: bold;
  color: $dark;
}
</style>
